import { render, staticRenderFns } from "./common-icon.vue?vue&type=template&id=52711984&"
import script from "./common-icon.vue?vue&type=script&lang=js&"
export * from "./common-icon.vue?vue&type=script&lang=js&"
import style0 from "./common-icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "common-icon.vue"
export default component.exports